import React, { Component } from 'react'

class SignUp extends Component{
  constructor(props){
    super(props)
    this.state = {
      value: '',
      error: '',
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(event) {
    const value = event.target.value

    this.setState({value})
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.state.value.length === 0) {
      this.setState({error: "Emailfältet kan inte vara blankt"})
    } else {
      this.props.landingCreateUser(this.state.value, this.props.premiumSelected).then(res => {
        if (res === 403) {
          this.setState({error: "Det finns redan en användare med den email adressen"})
        } else if (res === 200) {
          this.props.hideSignUp()
        } else {
          this.setState({error: "Något gick fel. Ladda om sidan"})
        }
      })
    }
  }

  render() {
    return(
      <div className="Landing-SignUp">
        <h3>Skapa abonnemang</h3>
        <p>
          Ange din emailadress och klicka på forsätt. Checka sedan ut med Klarna
        </p>
        <p>{this.state.error}</p>
        <form onSubmit={this.handleSubmit}>
          <input
            type="text"
            placeholder="email"
            autoComplete="username email"
            value={this.state.value}
            onChange={this.handleChange}
            />
          <button type="submit">Fortsätt</button>
        </form>
      </div>
    )
  }
}

export default SignUp



// WEBPACK FOOTER //
// ./src/containers/landing/SignUp.jsx